import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { GetUserEventHistoryProps, UserEventHistoryResult } from "./types";

/**
 * Retrieve the list of user events for display in the User Search "Event History" tab
 */
export const getUserEventHistory = reactQueryFetcherAdapter(
  cacheKey,
  (signal, { userId }: GetUserEventHistoryProps): Promise<UserEventHistoryResult> => {
    return fetch(`/apps/user_event_history/${userId}`, "GET", { signal });
  }
);
